"use strict";

var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.debugShallowEqual = debugShallowEqual;
exports.debugShouldComponentUpdate = debugShouldComponentUpdate;
exports.shallowWithImmutablesEqual = shallowWithImmutablesEqual;
exports.smartEqual = smartEqual;
exports.smartShouldComponentUpdate = smartShouldComponentUpdate;
var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));
var _lodash = require("lodash");
var _immutable = _interopRequireWildcard(require("immutable"));
function _getRequireWildcardCache(nodeInterop) { if (typeof _WeakMap !== "function") return null; var cacheBabelInterop = new _WeakMap(); var cacheNodeInterop = new _WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? _Object$getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { _Object$defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function smartEqual(objA, objB) {
  if (_immutable.default.Iterable.isIterable(objA) || _immutable.default.Iterable.isIterable(objB)) {
    return (0, _immutable.is)(objA, objB);
  } else {
    return (0, _lodash.isEqual)(objA, objB);
  }
}
function shallowWithImmutablesEqual(objA, objB) {
  if (smartEqual(objA, objB)) {
    return true;
  }
  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }
  var keysA = (0, _keys.default)(objA);
  var keysB = (0, _keys.default)(objB);
  if (keysA.length !== keysB.length) {
    return false;
  }

  // Test for A's keys different from B.
  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwnProperty.call(objB, keysA[i]) || !smartEqual(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }
  return true;
}
function debugShallowEqual(objA, objB) {
  let ret = shallowWithImmutablesEqual(objA, objB);
  if (!ret) {
    for (var i in objA) {
      let eq = shallowWithImmutablesEqual(objA[i], objB[i]);
      /* eslint-disable no-console */
      if (!eq) {
        console.log('not equal', i);
      }
      /* eslint-enable no-console */
    }

    for (var j in objB) {
      let eq = shallowWithImmutablesEqual(objA[j], objB[j]);
      /* eslint-disable no-console */
      if (!eq) {
        console.log('not equal', i);
      }
      /* eslint-enable no-console */
    }
  }

  return ret;
}
function debugShouldComponentUpdate(name) {
  return function (nextProps, nextState) {
    if (!debugShallowEqual(this.props, nextProps)) {
      /* eslint-disable no-console */
      console.log(name, "props didn't equal");
      /* eslint-enable no-console */
      return true;
    }
    if (!debugShallowEqual(this.state, nextState)) {
      /* eslint-disable no-console */
      console.log(name, "states didn't equal");
      /* eslint-enable no-console */
      return true;
    }
    return false;
  };
}
function smartShouldComponentUpdate(nextProps, nextState) {
  return !smartEqual(this.props, nextProps) || !smartEqual(this.state, nextState);
}